var cifVn = ["301 201", "<g fill='none'><path fill='#DA251D' d='M.5.5h300v200H.5z'/><path fill='#FF0' d='M102.168 83.815l26.481 19.24-10.115 31.131 26.482-19.239 26.481 19.239-10.115-31.131 26.482-19.24h-32.841l-10.007-30.798-10.007 30.798z'/></g>"];

export { cifVn };

